<!-- scroll.vue -->
<template>
    <div class="scroll-box" @mouseenter="stopScroll" @mouseleave="startScroll">
        <div class="scroll-content" ref="scrollDom">
            <div class="scroll-item" v-for="(item, idx) in listData" :key="idx">
                <slot :data="item"></slot>
            </div>
            <div class="scroll-item" v-for="(item, idx) in listData" :key="idx + 'copy'">
                <slot :data="item"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HorizontalScroll',
    props: {
        dataList: {
            type: Array,
            default: () => []
        },
        speed: {
            type: Number,
            default: 1.5
        }
    },
    data() {
        return {
            listData: [],
            timer: null
        }
    },
    watch: {
        dataList: {
            handler(val) {
                this.listData = [...val]
                this.$nextTick(() => {
                    this.startScroll()
                })
            },
            immediate: true
        }
    },
    mounted() {
        this.startScroll()
    },
    beforeDestroy() {
        clearInterval(this.timer)
    },
    methods: {
        startScroll() {
            clearInterval(this.timer)
            const dom = this.$refs.scrollDom
            if (!dom) return
            this.timer = setInterval(() => {
                if (dom.scrollLeft >= dom.scrollWidth / 2) {
                    dom.scrollLeft = 0
                } else {
                    dom.scrollLeft += this.speed
                }
            }, 16)
        },
        stopScroll() {
            clearInterval(this.timer)
        }
    }
}
</script>

<style scoped>
.scroll-box {
    width: 100%;
    overflow: hidden;
}

.scroll-content {
    display: flex;
    overflow-x: hidden;
}

.scroll-item {
    flex-shrink: 0;
    margin-right: 16px;
}
</style>